/**
 * Check if a variable is null or undefined
 *
 * @param {*} value
 */
// eslint-disable-next-line import/prefer-default-export
export const isNil = (value) => {
  return typeof value === 'undefined' || value === null;
};
